module.exports = __webpack_public_path__ + "static/tastytrade-aus-fsg-60dbe667ac62a8b77ed80ab6fe5def9b.pdf";